import { decksApi } from '../../api/endpoints/decks';
import { studyApi } from '../../api/endpoints/study';
import { cardsApi } from '../../api/endpoints/cards';

/**
 * On app startup + online: eager-fetch lista talii → per-deck detail+queue → per image-card
 * image-detail. Strony są cache'owane przez Service Worker (`NetworkFirst` strategie z
 * `vite.config.ts` runtimeCaching). Image binaries cache'ują się side-effect gdy Konva
 * renderuje img tag (T1 strategy `image-binaries-v1` CacheFirst).
 *
 * Errors są silent (logged, not toast). User next visit retry.
 */
export async function runEagerPrefetch(): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return;

  let decks: { id: number }[];
  try {
    const response = await decksApi.listMy();
    decks = response.items as unknown as { id: number }[];
  } catch (err) {
    console.warn('[eager-prefetch] deck list failed', err);
    return;
  }

  await Promise.allSettled(
    decks.map(async (d) => {
      const detailP = decksApi.get(d.id).catch((err) => {
        console.warn(`[eager-prefetch] deck ${d.id} detail failed`, err);
      });
      const queueP = studyApi
        .getQueue(d.id)
        .then(async (q) => {
          const imageCardIds = q.items.filter((i) => i.cardType === 'image').map((i) => i.cardId);
          await Promise.allSettled(
            imageCardIds.map((cardId) =>
              cardsApi.getImageDetail(cardId).catch((err) => {
                console.warn(`[eager-prefetch] image-detail ${cardId} failed`, err);
              }),
            ),
          );
        })
        .catch((err) => {
          console.warn(`[eager-prefetch] queue deck=${d.id} failed`, err);
        });
      await Promise.all([detailP, queueP]);
    }),
  );
}
